<template>
<article class="card square" v-bind:class="cardband">
  <div class="article-details">
    <!-- These are to be filled with hex color values -->
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</article>
</template>

<script>
export default {
  name: 'Card',
  props: ['cardband']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
